// client/src/i18n/languages.js

import deFlag from "../img/flag/germany.webp";
import enFlag from "../img/flag/eanglish.webp";
import uaFlag from "../img/flag/ukraine.webp";
import itFlag from "../img/flag/italy.webp";
import plFlag from "../img/flag/poland.webp";
import esFlag from "../img/flag/spain.webp";
import frFlag from "../img/flag/france.webp";
import nlFlag from "../img/flag/nid.webp";
import daFlag from "../img/flag/dan.webp";
import noFlag from "../img/flag/norv.webp";

export const LANG_META = {
  de: {
    code: "de",
    short: "DE",
    label: "Deutsch",
    flag: deFlag,
  },
  en: {
    code: "en",
    short: "EN",
    label: "English",
    flag: enFlag,
  },
  uk: {
    code: "uk",
    short: "UK",
    label: "Українська",
    flag: uaFlag,
  },
  fr: {
    code: "fr",
    short: "FR",
    label: "Français",
    flag: frFlag,
  },
  nl: {
    code: "nl",
    short: "NL",
    label: "Nederlands",
    flag: nlFlag,
  },
  pl: {
    code: "pl",
    short: "PL",
    label: "Polski",
    flag: plFlag,
    },
  it: {
    code: "it",
    short: "IT",
    label: "Italiano",
    flag: itFlag,
  },
  da: {
    code: "da",
    short: "DA",
    label: "Dansk",
    flag: daFlag,
  },
  es: {
    code: "es",
    short: "ES",
    label: "Español",
    flag: esFlag,
  },
  no: {
    code: "no",
    short: "NO",
    label: "Norsk",
    flag: noFlag,
    },
};

export const SUPPORTED_LANGS = Object.keys(LANG_META);

export const AVAILABLE_MENU_LANGS = SUPPORTED_LANGS.map((code) => ({
  code,
  value: code,
  short: LANG_META[code].short,
  label: LANG_META[code].label,
  flag: LANG_META[code].flag,
  emoji: LANG_META[code].emoji,
}));